export default __webpack_public_path__ + "static/media/spr-design-system-dark-large.119671d0.png";